import healthdexDeErrorMessages from "@/constants/configuration/healthdex-de-error-message.json";

const normalFieldValidationKeywords = ["type", "enum", "required", "minLength", "maxLength", "minimum", "maximum", "multipleOf", "minItems"];

export const FormatEFORMErrorMessage = (error, dataElementId, schema) => {
    const errorDetail = error;
    //Detect whether property validation or dependent validation error
    if (errorDetail.schemaPath.startsWith("#/properties")) { // Property validation error
        const schemaPaths = errorDetail.schemaPath.split("/");
        const propertyKeys = schemaPaths.slice(2, schemaPaths.length - 1);
        const propertyDetail = FetchPropertyDetail(propertyKeys, schema);
        let message = propertyDetail?.title + " is not valid";
        // Process Error Type & Message
        const errorType = errorDetail.keyword === "enum" ? "type" : errorDetail.keyword;
        if (normalFieldValidationKeywords.includes(errorType)) {
            message = healthdexDeErrorMessages[dataElementId]?.[propertyKeys?.[0]]?.[errorType] ?? message;
        }
        return {
            message: message,
            ref: propertyKeys[0]
        }

    }
    else if (errorDetail.schemaPath.includes("allOf")) { // Dependent validation error
        const schemaPaths = errorDetail.schemaPath.split("/");
        //Finding last 2 keys of schema path
        const propertyKeys = schemaPaths.slice(schemaPaths.length - 2, schemaPaths.length - 1);
        const propertyDetail = FetchPropertyDetail([propertyKeys?.[0]], schema);
        if (propertyDetail) {
            let message = propertyDetail?.title + " is not valid";
            const errorType = "dependency";
            message = healthdexDeErrorMessages[dataElementId]?.[propertyKeys?.[0]]?.[errorType] ?? message;
            return {
                message: message,
                ref: propertyKeys[0]
            }
        }
    }
}

export const FetchPropertyDetail = (propertyKeys, schema) => {
    // Finding whether root schema property or sub property
    if (propertyKeys.length === 1) {
        return schema.properties[propertyKeys[0]];
    }
    else {
        return FetchPropertyDetail(propertyKeys.slice(2, propertyKeys.length), schema.properties[propertyKeys[0]]);
    }
}

export const RemoveDuplicatesByKey = (array, key) => {
    let result = new Set();
    return array?.filter((item) => {
        let keyValue = item[key];
        if (!result.has(keyValue)) {
            result.add(keyValue);
            return true;
        }
        return false;
    });
}